import { Clock, Mail, MapPin, Phone } from "lucide-react";

import { useState } from "react";

function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    company: "",
    service: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSuccess("");

    const response = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        access_key: "212dfa66-83f0-4ef8-85a9-10f40c58d45d",
        ...formData,
      }),
    });

    const result = await response.json();
    setLoading(false);

    if (result.success) {
      setSuccess("Message sent successfully! We'll get back to you soon.");
      setFormData({
        name: "",
        email: "",
        company: "",
        service: "",
        message: "",
      });
    }
  };

  const businessHours = [
    { day: "Monday - Friday", hours: "9:00 AM - 6:00 PM" },
    { day: "Saturday", hours: "Closed" },
    { day: "Sunday", hours: "Closed" },
  ];

  return (
    <div className="pt-28 pb-20">

      {/* HERO */}
      <section className="bg-gradient-to-r from-gray-900 to-gray-800 py-20 text-center">
        <div className="mx-auto max-w-4xl px-4">
          <h1 className="mb-6 text-4xl font-bold text-white sm:text-5xl">
            Get in Touch
          </h1>
          <p className="text-lg text-gray-300">
            Ready to transform your business? Let’s build something great together.
          </p>
        </div>
      </section>

      {/* CONTENT */}
      <section className="mx-auto max-w-7xl px-4 py-20">
        <div className="grid gap-12 lg:grid-cols-2">

          {/* FORM */}
          <div className="rounded-xl bg-white p-8 shadow">
            <h2 className="mb-6 text-3xl font-bold text-gray-800">
              Send us a Message
            </h2>

            <form onSubmit={handleSubmit} className="space-y-5">
              <input type="hidden" name="subject" value="New Contact Submission" />

              <div>
                <label className="block mb-1 font-medium">Name *</label>
                <input
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="w-full rounded-md border px-4 py-2"
                />
              </div>

              <div>
                <label className="block mb-1 font-medium">Email *</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full rounded-md border px-4 py-2"
                />
              </div>

              <div>
                <label className="block mb-1 font-medium">Company</label>
                <input
                  name="company"
                  value={formData.company}
                  onChange={handleChange}
                  className="w-full rounded-md border px-4 py-2"
                />
              </div>

              <div>
                <label className="block mb-1 font-medium">Service</label>
                <select
                  name="service"
                  value={formData.service}
                  onChange={handleChange}
                  className="w-full rounded-md border px-4 py-2"
                >
                  <option value="">Select a service</option>
                  <option>Apache Kafka</option>
                  <option>Apache Flink</option>
                  <option>Confluent Cloud</option>
                  <option>Full Stack Development</option>
                  <option>Fivetran</option>
                  <option>AI / Machine Learning</option>
                  <option>Databricks</option>
                  <option>Snowflake</option>
                  <option>Microsoft Fabric</option>
                </select>
              </div>

              <div>
                <label className="block mb-1 font-medium">Message *</label>
                <textarea
                  name="message"
                  rows="5"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  className="w-full rounded-md border px-4 py-2"
                />
              </div>

              <button
                type="submit"
                disabled={loading}
                className="w-full rounded-md bg-orange-500 py-3 font-semibold text-white hover:bg-orange-600"
              >
                {loading ? "Sending..." : "Send Message"}
              </button>

              {success && (
                <p className="text-green-600 text-center mt-4">{success}</p>
              )}
            </form>
          </div>

          {/* INFO */}
          <div className="space-y-8">

            <div className="rounded-xl bg-white p-8 shadow">
              <h2 className="mb-6 text-2xl font-bold">Contact Information</h2>

              <div className="space-y-4 text-gray-700">
                <p className="flex items-center">
                  <Mail className="mr-3 text-orange-500" /> sales@xstreamminds.com
                </p>
                {/* <p className="flex items-center">
                  <Phone className="mr-3 text-orange-500" /> +1 (636) 298-3168
                </p> */}
                <p className="flex items-start">
                  <MapPin className="mr-3 mt-1 text-orange-500" />
              Alt.f CoWorking,
9th Floor, Kapil Kavuri Hub, 144, Survey 37, Financial District, Nanakramguda,
Telangana 500032
                </p>
              </div>
            </div>

            <div className="rounded-xl bg-white p-8 shadow">
              <h3 className="mb-4 text-xl font-bold flex items-center">
                <Clock className="mr-3 text-orange-500" /> Business Hours
              </h3>
              {businessHours.map((b) => (
                <div key={b.day} className="flex justify-between text-gray-700">
                  <span>{b.day}</span>
                  <span className="font-semibold">{b.hours}</span>
                </div>
              ))}
            </div>

            <div className="bg-white p-8 rounded-xl shadow-lg">
  <h3 className="mb-6 text-2xl font-bold text-gray-800">
    Follow Us
  </h3>

  <div className="flex gap-4">
    {/* LinkedIn */}
    <a
      href="https://www.linkedin.com/company/xstream-minds-pvt-ltd/posts/?feedView=all"
      target="_blank"
      rel="noopener noreferrer"
      className="flex h-12 w-12 items-center justify-center rounded-lg bg-orange-500 text-white transition hover:bg-gray-900"
    >
      <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.065 2.065 0 110-4.13 2.065 2.065 0 010 4.13zM7.119 20.452H3.555V9h3.564v11.452z" />
      </svg>
    </a>

    {/* Twitter / X */}
    <a
      href="https://x.com/Xstream_Minds"
      target="_blank"
      rel="noopener noreferrer"
      className="flex h-12 w-12 items-center justify-center rounded-lg bg-orange-500 text-white transition hover:bg-gray-900"
    >
      <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
        <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417A9.867 9.867 0 012 19.54a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"/>
      </svg>
    </a>
  </div>
</div>


          </div>
        </div>
      </section>
    </div>
  );
}
export default Contact;